import { string } from 'yup';
import { CalendarDateService, l10nEnService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';

export type DobValidationOpts = {
  adult?: boolean;
  requiredMsg?: string;
  validMsg?: string;
  minMsg?: string;
  maxMsg?: string;
  adultMsg?: string;
};

export const createDobFieldValidation = (l10n: typeof l10nEnService, opts?: DobValidationOpts) => {
  let baseValidation = string()
    .test({
      name: 'dob-required',
      test: (value) => {
        const length = value?.replace(/[^0-9]/g, '').length;

        return !!length;
      },
      message: opts?.requiredMsg ?? l10n.validations.dob.required
    })
    .test({
      name: 'dob-valid',
      test: (value) => {
        const length = value?.replace(/[^0-9]/g, '').length;

        return length === 8 && CalendarDateService.date(value, DateFormats.DEFAULT_DATE, true).isValid();
      },
      message: opts?.validMsg ?? l10n.validations.dob.notAValidDate
    })
    .test({
      name: 'dob-min',
      test: (value) => {
        const date = CalendarDateService.date(value);
        const minDate = CalendarDateService.date().subtract(100, 'year');

        return date.isSameOrAfter(minDate);
      },
      message: opts?.minMsg ?? l10n.validations.dob.ageLessThan100
    })
    .test({
      name: 'dob-max',
      test: (value) => {
        const date = CalendarDateService.date(value);
        const maxDate = CalendarDateService.date();

        return date.isBefore(maxDate);
      },
      message: opts?.maxMsg ?? l10n.validations.dob.dateInThePast
    })
    .defined(l10n.validations.dob.required);

  if (opts?.adult) {
    baseValidation = baseValidation.test({
      name: 'dob-adult',
      message: opts?.adultMsg ?? l10n.validations.dob.atLeast18,
      test: (value) => {
        const date = CalendarDateService.date(value);
        const maxDate = CalendarDateService.date().subtract(18, 'years');

        return date.isBefore(maxDate);
      }
    });
  }

  return baseValidation;
};
